export default __webpack_public_path__ + "static/media/Divyanshu Tiwari.ec32868e.jpg";